import React from "react";
import { logEvent } from "../../Utils/logEvent";

class ClaraViewErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        const company = localStorage.getItem("company") || "claraView";
        let uid;
        try {
            uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi;
        } catch {
            uid = undefined;
        }
        logEvent({ app: company, uid, event: "ClaraView crashed", error });
    }

    handleStartOver = () => {
        const company = localStorage.getItem("company");
        localStorage.clear();
        const officeName = company?.includes("-") ? company.split("-")[1] : null;
        window.location.href = officeName ? `/${officeName}` : "/";
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="h-dvh w-full flex flex-col items-center justify-center text-center px-8 font-novatica">
                    <p className="text-lg font-medium text-[#2C2D24] mb-3">Something went wrong.</p>
                    <p className="text-sm text-claraview-tertiary mb-6">Please start over to continue.</p>
                    <button
                        type="button"
                        onClick={this.handleStartOver}
                        className="text-base font-medium rounded-md py-3 px-6 text-white bg-[#2C2D24]"
                    >
                        Start Over
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ClaraViewErrorBoundary;
